import Header from "./Header";
import "./BlackLabel.css";
import {
  collapseContentSection,
  hideSectionBanner,
  hideTeamInfoPanel,
  openItem,
  setServiceData,
  showContentSection,
  startHeaderFade,
  showAcceptingForm,
  showHeroBanner,
  showMainMenu,
} from "../features/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import PrivateServices from "./MainMenu";
import { toSlug } from "../utils/slug";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Footer from "./Footer";
import PrivateServiceMenu from "./PrivateServiceMenu";
import BlackLabelTeam from "./teams/BlackLabelTeam";
import axios from "axios";
import poolsideFittingGrey from "../assets/poolside-fitting-grey.png";
import heroVideo from "../assets/hero-video.mp4";
import ExploreMenu from "./ExploreMenu";

export default function BlackLabel() {
  const location = useLocation();

  const segments = location.pathname.split("/").filter(Boolean);

  // Example:
  // /services/wardrobe-services/couture-hand-cleaning
  // ["services", "wardrobe-services", "couture-hand-cleaning"]

  const sectionSlug = segments[1];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    expanded,
    showTopHeroBanner,
    serviceList,
    switchServiceList,
    privateService,
    disolveprivateService,
    teamsMenu,
    serviceData,
    isMenuSectionClicked,
  } = useSelector((state) => state.service);
  const [isExploreMenuOpen, setIsExploreMenuOpen] = useState(false);
  const [isExploreMenuClosing, setIsExploreMenuClosing] = useState(false);
  const exploreMenuCloseTimerRef = useRef(null);
  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "/service", {
        params: { _ts: Date.now() },
      });

      dispatch(setServiceData(response.data));
    } catch (error) {
      console.error("API error:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (exploreMenuCloseTimerRef.current) {
        clearTimeout(exploreMenuCloseTimerRef.current);
      }
    };
  }, []);

  const forceCloseExploreMenu = useCallback(() => {
    if (exploreMenuCloseTimerRef.current) {
      clearTimeout(exploreMenuCloseTimerRef.current);
    }

    setIsExploreMenuOpen(false);
    setIsExploreMenuClosing(true);
    exploreMenuCloseTimerRef.current = setTimeout(() => {
      setIsExploreMenuClosing(false);
      exploreMenuCloseTimerRef.current = null;
    }, 1400);
  }, []);

  const collapseFooterLegal = useCallback(() => {
    window.dispatchEvent(new Event("blacklabel:collapse-footer-legal"));
  }, []);

  const section = useMemo(() => {
    return serviceData?.find((s) => toSlug(s.title) === sectionSlug);
  }, [sectionSlug, serviceData]);

  const handleOpenAcceptingForm = () => {
    collapseFooterLegal();

    if (window.innerWidth <= 840) {
      dispatch(showAcceptingForm());
      return;
    }

    dispatch(showAcceptingForm());
    dispatch(collapseContentSection());
  };

  return (
    <div className="blacklabel-wrapper">
      {/* HEADER COMPONENT */}
      <Header onOpenAcceptingForm={handleOpenAcceptingForm} onOpenExploreMenu={() => {
        if (isExploreMenuOpen) {
          forceCloseExploreMenu();
          dispatch(showHeroBanner());
        } else {
          collapseFooterLegal();
          if (exploreMenuCloseTimerRef.current) {
            clearTimeout(exploreMenuCloseTimerRef.current);
            exploreMenuCloseTimerRef.current = null;
          }
          setIsExploreMenuClosing(false);
          setIsExploreMenuOpen(true);
          dispatch(showMainMenu());
        }
      }} onBeforeServiceNavigate={() => {
        if (isExploreMenuOpen || isExploreMenuClosing) {
          forceCloseExploreMenu();
        }
      }} />

      {/* CONTENT */}
      <main
        // onClick={(e) => {
        //   e.stopPropagation();
        //   dispatch(collapseContentSection());
        // }}
        className={`blacklabel-content section ${isMenuSectionClicked ? "h-full" : ""} ${privateService ? "d-none" : ""} ${showTopHeroBanner ? "" : "d-none"} ${serviceList || switchServiceList ? "d-none" : ""}`}
      >
        <video
          className="hero-img-show-only-on-mobile"
          src={heroVideo}
          autoPlay
          muted
          playsInline
        />
        <p className="eyebrow">WHAT IS SUDSIES BLACK LABEL?</p>

        <h1 className="headline">
          <span className="accent">Private</span> Garment
          <br />
          and <span className="accent">Estate</span> Textile
          <br />
          Care <span className="accent">Services</span>.
        </h1>

        <div className="description">
          <p>
            Sudsies Dry Cleaning Black Label is an invitation-only service for
            Sudsies guests who require concierge garment and textile care. A
            dedicated concierge serves as your single point of contact and
            coordinates prioritized handling, with in-home, on-vessel, or
            on-premises service available upon request.
          </p>

          <p>
            We care for exceptional wardrobes, estate textiles, and vessel
            textiles with discretion at every step. Free pickup and delivery are
            always included.
          </p>
        </div>

        <div className="mobile-inline-footer">
          <Footer />
        </div>
      </main>

      <div

        className={`section  ${isMenuSectionClicked ? "h-full" : ""} ${showTopHeroBanner ? "d-none" : ""} ${!privateService ? "" : "d-none"} ${expanded || switchServiceList ? "d-none" : ""} ${serviceList ? "d-none" : ""} `}
      >
        <PrivateServices />
      </div>

      <div
        className={`section service-category-section ${isMenuSectionClicked ? "h-full" : ""} ${serviceList ? "" : "d-none"} ${!privateService ? "" : "d-none"}`}
      >
        {section ? (
          <>
            <section className="pgc-wrapper">
              <p className="pgc-eyebrow">{section.title}</p>

              <h1 className="pgc-title">
                <span>Private</span> {section.title}
              </h1>
              <div className="pgc-container">
                {/* LEFT */}
                <div className="pgc-left">
                  <ul className="pgc-list">
                    {section?.items?.map((item, i) => (
                      <li
                        key={i}
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(startHeaderFade());
                          dispatch(showContentSection());
                          dispatch(openItem(item));
                          dispatch(hideSectionBanner());
                          navigate(
                            `/services/${toSlug(section.title)}/${toSlug(item.label)}`,
                          );
                        }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                </div>
                {/* RIGHT */}
                <div className="pgc-right">
                  <img
                    src={poolsideFittingGrey}
                    alt="Garment Care Illustration"
                  />
                </div>
              </div>
              {/* BOTTOM */}
              <div className="pgc-bottom">
                <h2>{section.heading}</h2>
                <p>{section.short_description}</p>

                {/* <button className="pgc-btn">{section.btn_text}</button> */}
              </div>
              <div className="service-category-footer">
                <Footer />
              </div>
            </section>
          </>
        ) : (
          <></>
        )}
      </div>

      <div
        // onClick={(e) => {
        //   e.stopPropagation();
        //   dispatch(collapseContentSection());
        // }}
        className={`section  ${isMenuSectionClicked ? "h-full" : ""} ${privateService ? "" : "d-none"} ${disolveprivateService ? "disolve" : ""}`}
      >
        <PrivateServiceMenu />
      </div>

      <div
        onClick={(e) => {
          e.stopPropagation();
          // dispatch(collapseContentSection());
          dispatch(hideTeamInfoPanel());
        }}
        className={`blacklabel-teams-menu section  ${isMenuSectionClicked ? "h-full" : ""} ${privateService ? "d-none" : ""} ${teamsMenu ? "" : "d-none"}`}
      >
        <BlackLabelTeam />
      </div>

      <div
        // // onClick={(e) => {
        // //   e.stopPropagation();
        // //   dispatch(collapseContentSection());
        // }}
        className={`footer-section ${serviceList && !privateService ? "mobile-service-category-footer-hidden" : ""} ${showTopHeroBanner && !privateService && !serviceList && !switchServiceList ? "mobile-hide-landing-footer" : ""} ${disolveprivateService ? "disolve" : ""}`}
      >
        <Footer />
      </div>

      <ExploreMenu
        isOpen={isExploreMenuOpen}
        isClosing={isExploreMenuClosing}
        onClose={forceCloseExploreMenu}
      />
    </div>
  );
}
